// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__153KB","inputWrap":"styles_inputWrap__3X-Ol","input":"styles_input__3PIIQ"};